import { gql } from '@apollo/client';
export interface FilterQueryTriplePlay {
  category: string;
  name: string;
  value: any;
}

export const generateFiltersTriplePlay = (
  currentFilters: FilterQueryTriplePlay[],
  newQueries: FilterQueryTriplePlay[]
) => {
  let newFilters: FilterQueryTriplePlay[] = [...currentFilters];
  for (const query of newQueries) {
    if (!query.value) {
      newFilters = newFilters.filter((filter) => filter.name !== query.name);
      continue;
    }
    const propertyToChangeIndex = currentFilters.findIndex(
      (filter) => filter.name === query.name
    );
    if (propertyToChangeIndex > -1) {
      newFilters[propertyToChangeIndex] = { ...query };
    } else {
      newFilters.push(query);
    }
  }

  return newFilters;
};

export const calculateTriplePlayQuery = gql`
  query calculate(
    $postalCode: String
    $houseNumber: Int
    $houseNumberAddition: String
    $filters: [TriplePlay_InputFilterDataInput!]
    $comparisonId: String
    $retention: String
  ) {
    calculateTriplePlay(
      input: {
        address: {
          houseNumber: $houseNumber
          postalCode: $postalCode
          houseNumberAddition: $houseNumberAddition
        }
        filters: $filters
        comparisonId: $comparisonId
        retention: $retention
      }
    ) {
      products {
        subscriptionId
        subscriptionName
        orderFormId
        tags
        supplier {
          id
          name
        }
        contractInformation {
          deliveryTime {
            unit
            available
            text
          }
        }
        contractInformation {
          deliveryTime {
            unit
            available
            text
          }
          freeStartDate {
            available
            period {
              unit
              available
              text
            }
            remarks
          }
          contractDuration {
            unit
            available
            text
          }
          contractExtension {
            unit
            available
            text
          }
          contractExtension {
            unit
            available
            text
          }
          noticePeriod {
            unit
            available
            text
          }
        }
        specialOfferWrapper {
          validUntil
          validUntilInUnixTime
          specialOffer {
            version
            text
          }
        }
        packageCosts {
          monthlyCosts {
            standardRate
            priceList {
              priceList {
                periodInMonth
                amount
              }
            }
          }
          onceOffCosts {
            postageCosts
            connectionCosts
            closingCosts
            installations {
              installation {
                available
                name
                rate
                remarks
                required
              }
            }
          }
          discount
          discountSource
          cbDiscount
          total
        }
        customerBenefits {
          customerBenefit {
            supplier {
              id
              name
            }
            product {
              id
              type
              remark
            }
            name
            advantages {
              total
              advantages {
                category
                descriptions {
                  description {
                    type
                    remark
                  }
                }
                mutations {
                  subscription {
                    id
                    available
                    remark
                    offers {
                      exclusive
                      validity
                      remark
                      offers {
                        version
                        remark
                      }
                    }
                  }
                }
              }
            }
          }
        }
        servicesWrapper {
          networkInformation {
            internetSpeed {
              downloadSpeedInMb
              downloadSpeedInBytes
              uploadSpeedInBytes
              uploadSpeedInMb
            }
            network {
              supplierName
              signal
            }
            email {
              emailBoxes {
                numberOfEmailBoxes
                sizeOfEmailBox
              }
              numberOfAliasesPerBox
              spamFilter {
                available
                name
              }
              virusFilter {
                available
                name
              }
              webmail {
                available
                remarks
              }
            }
            modems {
              modem {
                name
              }
            }
            dataLimit {
              available
              limit
              rate
              remarks
            }

            homepage {
              available
              mode
              sizeInMb
            }
            newsgroups {
              available
            }
            fixedIp {
              available
            }
            ownServer {
              available
            }
          }
          televisionInfo {
            hDTV {
              available
              remarks
            }
            numberTvs {
              available
              remarks
            }
            channels {
              numberOfTvChannels
              numberOfHdChannels
              numberOfRadioChannels
              channelsOverview {
                television {
                  numberOfCategories
                  categories {
                    id
                    name
                    numberOfTelevisionChannels
                    channel {
                      id
                      optional
                      hd
                      app
                      outside
                      missedStart
                      programMissed
                      name
                    }
                  }
                }
              }
              channelsPackages {
                channelPackages {
                  name
                  remarks
                  costs {
                    monthlyCosts {
                      costSpecifics {
                        rate
                        periodInMonth
                        remarks
                      }
                    }
                    onceOffCosts {
                      costSpecifics {
                        periodInMonth
                        rate
                        remarks
                      }
                    }
                  }
                }
              }
              numberOfTvChannels
              numberOfHdChannels
              numberOfRadioChannels
            }
            decoders {
              decoders {
                name
                rate
                remarks
              }
            }
            recordPrograms {
              available
              numberOfChannels
              remarks
            }
            pauseLiveTv {
              available
            }
            missedPrograms {
              available
              numberOfChannels
              remarks
            }
            recordPrograms {
              technic
              recordingTimeInHours
              available
              rate
              remarks
            }
            videoOnDemand {
              available
              numberOfChannels
              remarks
            }
            guide {
              available
              numberOfChannels
              remarks
            }
          }
          callInfo {
            numberPorting {
              available
              numberOfChannels
              remarks
            }
            callerIdVisibility {
              available
              numberOfChannels
              remarks
            }
            rate {
              startingRate
              rateWithinRegion
              rateOutsideRegion
              mobile
            }
            bundles {
              available
              numberOfChannels
              remarks
            }
            voicemail {
              available
              numberOfChannels
              remarks
            }
          }
        }
      }
      comparisonId
    }
  }
`;

export const calculateOsTriplePlayQuery = gql`
  mutation CalculateTriplePlay($request: CalculationRequestInput!) {
    calculateTriplePlay(input: { request: $request }) {
      calculationResult {
        policyPolicyDetails {
          productCode
          affiliateUrl
          refKey
          companyNameDescription
          underwritingCompanySpecifics {
            refKey
            underwritingResult
          }
          customProperties {
            customAttributes {
              description
              value
            }
            supplierKrn
          }
          tags
          grossPremiumInstallment
          netPremiumInstallment
          paymentTermInMonths
          totalInstallmentAmount
        }
        commonTechnical {
          transactionReference
          accessCode
          googleAnalyticsId
          senderId
          sessionId
        }
      }
    }
  }
`;
